import { Box } from '@mui/material';
import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { buamatogVerificationKey, uuidv4 } from './Types/Utility';

interface Props {
    params?: {
        code: string,
    }
}

class JoinBuamatog extends Component<Props, { navigateForward : boolean }> {
    constructor(props : Props) {
        super(props);
        
        this.state={
            navigateForward: false,
        }
    }
    

    componentDidMount() {        
        const buamatogyear = (new Date()).getFullYear();
        const buamatogkey = buamatogVerificationKey();
        const value = localStorage.getItem(buamatogkey);
        if (!value) {
            localStorage.clear();

            const uuid = uuidv4();
            localStorage.setItem(buamatogkey, 'buamatog-'+buamatogyear+'-' + uuid);
        }
        this.setState({
            navigateForward: true,
        });
    }
    

    render() {
        const { navigateForward } = this.state;
        return (
            <React.Fragment>
                {navigateForward
                    ? <Box>Boat amoi</Box>
                    : <Navigate to={"/register"}/>
                }
            </React.Fragment>
        );
    }
}

export default JoinBuamatog;